import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/business/importer/businessImporterActions'

export default importerReducers(actions)
